import { LoadingOverlay } from '@mantine/core';
import { FC, ReactElement } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useJwtClaims } from '../../Service/Context/AuthContext';
import { PagePermissionS } from '../../Service/PagePermissionS';
import PagePermissionDeniedPage from './PagePermissionDeniedPage';

const PagePermissionGuard: FC<{ children?: ReactElement; ownerOnly?: boolean }> = ({ children, ownerOnly = false }) => {
  const { pathname } = useLocation();
  const { profileId, role, scopes = [] } = useJwtClaims();

  // Claims are decoded asynchronously. Do not briefly render a protected page
  // before the user's profile and scopes are available.
  if (!profileId) {
    return <LoadingOverlay visible loaderProps={{ size: 'xl' }} />;
  }

  // Older tokens do not contain a role and must retain their owner permissions.
  if (role === 'TENANT' && (ownerOnly || !PagePermissionS.hasPagePermission(pathname, scopes))) {
    return <PagePermissionDeniedPage />;
  }

  return children || <Outlet />;
};

export default PagePermissionGuard;
